/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 895);
/******/ })
/************************************************************************/
/******/ ({

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function ($, w, d) {

  var FORCE_DISABLED_CLASS_NAME = 'errorUrl';

  var $w = $(w),
      $d = $(d);

  var selectKubun02;

  dn.ready().then(function () {

    var pageArchive = false;
    var $prefArea = $('.selectArea[name="pref02"] option');
    var $prefClone = $prefArea.clone();

    if ($('body').hasClass('pageArchive')) {
      pageArchive = true;
      selectKubun02 = "";
    }

    // 一覧ページの場合の処理
    if (pageArchive) {

      // 現在のページのIDを選択
      var thisPageId = GetFileName(location.href);

      // フォームを現在のページIDで変更
      if (!thisPageId.match(/[^0-9]+/)) {
        // 都道府県での絞り込み時(エリアも絞り込む)
        $('.selectArea[name="pref02"]').val(thisPageId);
        var selectPrefArea = $('.selectArea[name="pref02"] option:selected').attr('class');
        $('.selectArea[name="area02"]').val(selectPrefArea);
      } else {
        // エリアでの絞り込み時
        $('.selectArea[name="area02"]').val(thisPageId);
      }

      // ハッシュがある場合(設置区分)
      if (location.hash) {
        var $tabs = $('.mdToggleTab');
        var now = $tabs.attr('data-init');
        var target = location.hash.replace('#', '');
        $('.mdToggleBody[data-index="' + now + '"]').hide();
        $('.mdToggleBody[data-index="' + target + '"]').css('display', 'table-row-group');
        $tabs.attr('data-init', target);

        $tabs.find('.current').removeClass('current');
        $tabs.find('li a[data-target="' + target + '"]').parent().addClass('current');
      } else {
        // ハッシュがない場合、H2のエリアに移動
        if (dn.$store.getters['mq/pc']) {
          location.href = location.href + '#kouritu';
        }
      }

      // タブクリック時のハッシュ書き換え
      $d.on('click', '.mdToggleTab li a', function (e) {
        var target = $(this).data('target');
        window.history && history.replaceState && history.replaceState('', document.title, window.location.pathname + window.location.search + '#' + target);
        return false;
      });
    }

    /*
     * 大学別分析データ(href)
     * ================================================== */
    function toggleLinkArea() {

      var selectArea02 = $('.selectArea[name="area02"]').val();
      var selectPref02 = $('.selectArea[name="pref02"]').val();
      var selectKubun02 = $('input[name="kubun02"]:checked').val();

      // 一覧ページの時は設置区分はなし
      if (pageArchive) {
        selectKubun02 = "";
      }

      var flg02 = true;

      // 「検索」ボタンアクティブ判定
      //※現状 「エリア」、「都道府県」と区分が選択されていればアクティブ
      if (selectArea02 == "" && selectPref02 == "" || !selectKubun02 && !pageArchive) {
        flg02 = false;
      }

      // 選択されているエリアによって都道府県のオプションを変更
      var selectPrefArea = $('.selectArea[name="pref02"] option:selected').attr('class');

      var nowSelect = $('.selectArea[name="pref02"]').val();
      $('.selectArea[name="pref02"]').empty().append($prefClone);

      if (!selectArea02 == '') {
        $('.selectArea[name="pref02"]').empty().append($prefClone);
        $('.selectArea[name="pref02"] option').each(function () {
          if (!$(this).hasClass(selectArea02) && $(this).attr('class')) {
            $(this).remove();
          }
        });
      }

      $('.selectArea[name="pref02"]').val(nowSelect);

      // もし選択している都道府県が選択しているエリア内でなければ都道府県選択をリセット
      if (selectPrefArea != selectArea02 && selectArea02 != '') {
        $('.selectArea[name="pref02"]').val('');
        selectPref02 = '';
      }

      //
      if (flg02) {
        if (!pageArchive) {
          selectKubun02 = '#' + selectKubun02;
        }
        if (selectPref02 != '') {
          $('.btnSearch a').removeClass(FORCE_DISABLED_CLASS_NAME).attr('href', './' + selectPref02 + '.html' + selectKubun02).removeAttr('nohref');
        } else {
          $('.btnSearch a').removeClass(FORCE_DISABLED_CLASS_NAME).attr('href', './' + selectArea02 + '.html' + selectKubun02).removeAttr('nohref');
        }
      } else {
        $('.btnSearch a').addClass(FORCE_DISABLED_CLASS_NAME).attr('href', 'javascript:void(0);').attr('nohref', 'nohref');
      }
    }
    toggleLinkArea();
    $('.selectArea[name="area02"], .selectArea[name="pref02"], input[name="kubun02"]').change(function () {
      toggleLinkArea();
    });
  });

  // 現在のファイル名を返す関数
  function GetFileName(file_url) {
    file_url = file_url.substring(file_url.lastIndexOf('/') + 1, file_url.length);
    file_url = file_url.substring(0, file_url.indexOf('.'));
    return file_url;
  }
})(jQuery, window, document);

/***/ })

/******/ });


// WEBPACK FOOTER //
// doukou/siboudoukou/js/page.js